/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_OverdueInputs */

const vi_sla_overdue = /** @type {(inputs: Sla_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quá hạn`)
};

/**

* @param {Sla_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_overdue = /** @type {((inputs?: Sla_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_overdue(inputs)
});